import { useState } from "react";
import InputMask from "react-input-mask";
import api_publica from "components/utils/api-publica";
import StatusMessage from "components/status-message";
import useApiRequest from "hooks/useApiRequest";
import { StyleMessageBox } from "globalStyles";
import { StyleWrapperInput, Loader } from "globalStyles";
import Modal from "components/modal";
import Button from "components/button";
import {
    StyleContent,
    StyleTitleText,
    StyleParagraphText,
    StyleLuckNumberContainer,
    StyleDataBestDrive,
    StyleDescriptionBestDrive,
    StyleInfoBestDrive,
} from "./style";

export default ({isModalOpen, setIsModalOpen}) => {
    const { status, handleRequest } = useApiRequest();
    const [formData, setFormData] = useState({
        documento: "",
    });
    const [error, setError] = useState(false);
    const [resultContent, setResultContent] = useState([]);
    const [luckyNumber, setLuckyNumber] = useState({});
    const [bestDriveNoLuckyNumber, setBestDriveNoLuckyNumber] = useState([]);
    const handleFormDataInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    // 1: Identificação, 2: Numeros da sorte
    const [step, setStep] = useState(1);

    const handleSubmitFormDataSuccess = (response) => {
            if (response.data.length > 0) {
                const bestDriveLuckyNumber = response.data.filter((item) => item.numerosDaSorte.length > 0)[0];
                const bestDriveNoLuckyNumber = response.data.filter((item) => !item.numerosDaSorte.length > 0);
                setResultContent(response.data);
                setLuckyNumber(bestDriveLuckyNumber);
                setBestDriveNoLuckyNumber(bestDriveNoLuckyNumber);
                setStep(2);
            } else {
                setError(true);
            }
        };
    
        const handleSubmitFormData = async (evt) => {
            evt.preventDefault();
            setError(false);
            handleRequest(
                () => api_publica.get(`/participantes?Cpf=${formData.documento}`),
                handleSubmitFormDataSuccess,
                null
            );
        };
    
        const handleMaskDocument = (v) => {
            return "999.999.999-999";
        };

    return (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <StyleContent openedStep={step === 1}>
                <form onSubmit={handleSubmitFormData} autoComplete="off">
                    <StyleTitleText>
                        <strong>Identifique-se</strong>
                    </StyleTitleText>
                    <StyleParagraphText>
                        Para consultar o seu número da sorte, informe seus
                        dados.
                    </StyleParagraphText>
                    <StyleWrapperInput>
                        <label htmlFor="documento">CPF*</label>
                        <InputMask
                            placeholder="Somente números"
                            type="text"
                            id="documento"
                            name="documento"
                            mask={handleMaskDocument(formData.documento)}
                            maskChar={""}
                            value={formData.documento}
                            onChange={(e) => {
                                handleFormDataInputChange(e);
                            }}
                            required
                        />
                    </StyleWrapperInput>
                    <StatusMessage
                        error={status.error}
                        messages={status.messages}
                    />
                    <StyleWrapperInput className="text-center">
                        <Button type="submit" disabled={status.disabled}>
                            {status.disabled ? <Loader /> : "Acessar"}
                        </Button>
                    </StyleWrapperInput>
                    {error && (
                        <StyleMessageBox
                            className={`${
                                error ? "bg-danger" : "bg-success"
                            } text-white text-center`}
                        >
                            O CPF informado não está cadastrado. Para conhecer
                            os critérios de desclassificação, consulte o
                            regulamento no{" "}
                            <a
                                href="https://www.vw.com.br/promocao"
                                target="_blank"
                                rel="noreferrer"
                            >
                                www.vw.com.br/promocao{" "}
                            </a>
                        </StyleMessageBox>
                    )}
                </form>
            </StyleContent>
            <StyleContent openedStep={step === 2}>
                <StyleTitleText>
                    <strong>
                        Olá{" "}
                        <span style={{ textTransform: "capitalize" }}>
                            {resultContent[0]?.name.toLowerCase().split(" ")[0]}{" "}
                            {resultContent[0]?.name
                                .toLowerCase()
                                .split(" ")
                                .at(-1)}
                        </span>
                        ,
                    </strong>
                </StyleTitleText>

                {luckyNumber?.numerosDaSorte?.length > 0 && (
                    <>
                        <StyleLuckNumberContainer>
                            <div>
                                <h2>Seu número da sorte:</h2>

                                <strong>
                                    {
                                        luckyNumber.numerosDaSorte[0]
                                            .numeroDaSorte
                                    }
                                </strong>
                            </div>
                        </StyleLuckNumberContainer>
                        <StyleDataBestDrive>
                            <StyleDescriptionBestDrive>
                                Nome da Concessionária:
                            </StyleDescriptionBestDrive>
                            <StyleInfoBestDrive>
                                {luckyNumber.dealer}
                            </StyleInfoBestDrive>
                        </StyleDataBestDrive>
                        <StyleDataBestDrive>
                            <StyleDescriptionBestDrive>
                                Carro / Modelo do veículo do Test Drive:
                            </StyleDescriptionBestDrive>
                            <StyleInfoBestDrive>
                                {luckyNumber.model_Name} /{" "}
                                {luckyNumber.model_Version}
                            </StyleInfoBestDrive>
                        </StyleDataBestDrive>
                        <StyleDataBestDrive>
                            <StyleDescriptionBestDrive>
                                Número da Sorte:
                            </StyleDescriptionBestDrive>
                            <StyleInfoBestDrive className="highlight">
                                {luckyNumber.numerosDaSorte[0].numeroDaSorte}
                            </StyleInfoBestDrive>
                        </StyleDataBestDrive>
                    </>
                )}
                {bestDriveNoLuckyNumber?.length > 0 && (
                    <>
                        {bestDriveNoLuckyNumber.map(
                            (luckyNumberNoPrize, index) => (
                                <>
                                    <hr />
                                    <StyleDataBestDrive>
                                        <StyleDescriptionBestDrive>
                                            Nome da Concessionária:
                                        </StyleDescriptionBestDrive>
                                        <StyleInfoBestDrive>
                                            {luckyNumberNoPrize.dealer}
                                        </StyleInfoBestDrive>
                                    </StyleDataBestDrive>
                                    <StyleDataBestDrive>
                                        <StyleDescriptionBestDrive>
                                            Carro / Modelo do veículo do Test
                                            Drive:
                                        </StyleDescriptionBestDrive>
                                        <StyleInfoBestDrive>
                                            {luckyNumberNoPrize.model_Name} /{" "}
                                            {luckyNumberNoPrize.model_Version}
                                        </StyleInfoBestDrive>
                                    </StyleDataBestDrive>
                                    <StyleDataBestDrive>
                                        <StyleInfoBestDrive>
                                            Test Drive não elegível para número
                                            da sorte.
                                        </StyleInfoBestDrive>
                                    </StyleDataBestDrive>
                                </>
                            )
                        )}
                    </>
                )}
            </StyleContent>
        </Modal>
    );
}